export class Wifi {
    public name: string;
    public bssid: string;
    public latitude: number;
    public longitude: number;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/models/Wifi.ts